//userSlice
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InitialStateI } from '../../types/user';
import { getUsernameFromJWT } from '../../utils';

const initialState: InitialStateI = {
  user: {
    username: getUsernameFromJWT(localStorage.getItem('access_token') || ''),
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    logoutUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUser, logoutUser } = userSlice.actions;

export const selectUser = (state: any) => state.user;

export default userSlice.reducer;
